
import styles from "./PartWorkItemUsed.module.scss";
import { useState } from "react";


import pieeeeechart from 'assets/icons/pieeeeechart.png'
import Notification from "utils/Notifications";

import { ChangeAnswerAll } from "service/TestService";
import { EditorState, convertFromRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";

const PartWorkItemUsedAll = ({ item, item_selected, index, setRender,full_name }) => {

    const [notify, setNotify] = useState({
        isOpen: false,
        message: "",
        type: "",
    });



    const DraftContent = ({ draftData }) => {
        // Преобразуем данные из текста в объект
        let contentState;
        try {
            const parsedData = typeof draftData === "string" ? JSON.parse(draftData) : draftData;
            contentState = convertFromRaw(parsedData);
        } catch (error) {
            console.error("Ошибка обработки данных Draft.js:", error);
            return <p>Invalid content format</p>;
        }

        // Создаём состояние редактора для отображения
        const editorState = EditorState.createWithContent(contentState);

        return (
            <div st>
                <Editor editorState={editorState} readOnly toolbarHidden />
            </div>
        );
    };

    const [text, setText] = useState('');


    const handleChange = (event) => {
        // Обновляем состояние с текстом
        setText(event.target.value);
    };

    const [answersData, setAnswersData] = useState([]);

    const handleFileAndAnswerChange = (event, answerId) => {
        const file = event.target.files[0]; // Получаем файл

        setAnswersData(prevData => [
            ...prevData,
            { file, answerId }, // Добавляем новый объект с файлом и answerId
        ]);
    };


    const handleSliderChange = (event, answerId) => {
        const value = event.target.value; // Получаем новое значение слайдера

        setAnswersData(prevData => {
            // Проверяем, есть ли уже такой объект с answerId
            const existingAnswer = prevData.find(data => data.answerId === answerId);

            if (existingAnswer) {
                // Если есть, обновляем его значение слайдера
                return prevData.map(data =>
                    data.answerId === answerId ? { ...data, sliderValue: value } : data
                );
            } else {
                // Если нет, добавляем новый объект с answerId и значением слайдера
                return [...prevData, { answerId, sliderValue: value }];
            }
        });
    };


    const handleSelectChange = (event, answerId) => {
        const value = event.target.value; // Получаем новое значение из select

        setAnswersData(prevData => {
            // Проверяем, есть ли уже такой объект с answerId
            const existingAnswer = prevData.find(data => data.answerId === answerId);

            if (existingAnswer) {
                // Если есть, обновляем его значение
                return prevData.map(data =>
                    data.answerId === answerId ? { ...data, sequencesSelectedNumber: value } : data
                );
            } else {
                // Если нет, добавляем новый объект с answerId и значением
                return [...prevData, { answerId, sequencesSelectedNumber: value }];
            }
        });
    };


    const handleTextChange = (event, answerId) => {
        const value = event.target.value; // Получаем новый текст из textarea


        setAnswersData(prevData => {
            // Проверяем, есть ли уже такой объект с answerId
            const existingAnswer = prevData.find(data => data.answerId === answerId);

            if (existingAnswer) {
                // Если есть, обновляем его значение текста
                return prevData.map(data =>
                    data.answerId === answerId ? { ...data, textValue: value } : data

                );
            } else {
                // Если нет, добавляем новый объект с answerId и значением текста
                return [...prevData, { answerId, textValue: value }];
            }
        });
    };

    const handleNumericInputChange = (event, answerId) => {
        const value = event.target.value;

        // Проверяем, что введенное значение является числом
        const numericValue = isNaN(value) ? '' : value;

        setAnswersData(prevData => {
            const existingAnswer = prevData.find(data => data.answerId === answerId);

            if (existingAnswer) {
                return prevData.map(data =>
                    data.answerId === answerId ? { ...data, type_input_int: numericValue } : data
                );
            } else {
                return [...prevData, { answerId, type_input_int: numericValue }];
            }
        });
    };
    const handleTextInputChange = (event, answerId) => {
        const value = event.target.value;

        setAnswersData(prevData => {
            const existingAnswer = prevData.find(data => data.answerId === answerId);

            if (existingAnswer) {
                return prevData.map(data =>
                    data.answerId === answerId ? { ...data, type_input_txt: value } : data
                );
            } else {
                return [...prevData, { answerId, type_input_txt: value }];
            }
        });
    };
    const handleCheckboxChange = (answerId) => {
        setAnswersData((prevData) => {
            const existingAnswer = prevData.find((data) => data.answerId === answerId);

            if (existingAnswer) {
                // Если объект уже существует, обновляем его `isChecked`
                return prevData.map((data) =>
                    data.answerId === answerId ? { ...data, isChecked: !data.isChecked } : data
                );
            } else {
                // Если объекта нет, добавляем его с `isChecked: true`
                return [...prevData, { answerId, isChecked: true }];
            }
        });
    };

    const handleCheckboxChangeOne = (answerId) => {
        setAnswersData((prevData) => {
            const existingAnswer = prevData.find((data) => data.answerId === answerId);

            if (existingAnswer) {
                // Если объект уже существует, обновляем его состояние
                return prevData.map((data) =>
                    data.answerId === answerId
                        ? { ...data, isChecked: true } // Отмечаем текущий чекбокс
                        : { ...data, isChecked: false } // Снимаем остальные
                );
            } else {
                // Если объекта нет, добавляем его и сразу отмечаем
                return prevData.map((data) => ({ ...data, isChecked: false })) // Сбрасываем остальные
                    .concat({ answerId, isChecked: true }); // Добавляем новый объект
            }
        });
    };

    const handleSubmit = (id) => {

        if (item.type_answer === "fileUpload" && !answersData.some(data => data.file)) {
            setNotify({
                isOpen: true,
                message: "Пожалуйста, Загрузите файл перед отправкой.",
                type: "error",
            });
            return;
        }
        try {

            const formData = new FormData();
            formData.append('full_name', full_name);

            const answerArray = answersData.map(row => ({
                answer: row.answerId,
                ranswer: row.sliderValue || null,
                sequences_selectedNumber: row.sequencesSelectedNumber || null,
                free_response: row.textValue || null,
                type_input_int: row.type_input_int || null,
                type_input_txt: row.type_input_txt || null,
                right_answer: row.isChecked || false,


            }));
            formData.append('answer_arr', JSON.stringify(answerArray));
            answersData.forEach((row, index) => {
                if (row.file) {
                    formData.append(`file[${index}]`, row.file);
                }
            });




            ChangeAnswerAll(id, formData);
            setAnswersData([]);
            setNotify({
                isOpen: true,
                message: "Данные успешно отправлены!",
                type: "success",
            });
            setRender(true);
        } catch (error) {
            console.error("Ошибка отправки данных:", error);
            setNotify({
                isOpen: true,
                message: "Ошибка при отправке данных!",
                type: "error",
            });
        }

    };


    const numOptions = item.answer_part_worktest.length;
    return (


        <div className={styles.answer_card_selection}>

            {item.image &&
                <img
                    src={item.image}
                    className={styles.img_file}
                />
            }
            <div className={styles.answer_card_selection_body}>

                <h3 style={{ marginTop: "-16px" }}> <DraftContent draftData={item.body} /></h3>
                {Number(item_selected) !== Number(item.id) &&
                    <div className={styles.answer_card_selection_body_answer}>
                        {item.answer_part_worktest.map((answer, index) => (
                            <>

                                <div style={{ width: '100%' }}>
                                    {(item.type_answer !== "freeTextAnswer" && item.type_answer !== "infoText" && item.type_answer !== 'fileUpload') ? (
                                        <div className={styles.answer_card_header}>


                                            {(item.type_answer === 'sequenceOrdering') &&
                                                <>
                                                    <DraftContent draftData={answer.title} />
                                                    <select
                                                        className={styles.point_check_num_text}
                                                        value={answersData.find(data => data.answerId === answer.id)?.sequencesSelectedNumber}
                                                        onChange={(e) => handleSelectChange(e, answer.id)}
                                                    >
                                                        <option key={0} value={0}>{"Выберите последовательность"}</option>
                                                        {

                                                            Array.from({ length: numOptions }, (_, index) => index + 1).map(number => (
                                                                <option key={number} value={number}>{number}</option>
                                                            ))
                                                        }
                                                    </select>
                                                </>
                                            }
                                            {(item.type_answer === 'slider') &&
                                                <div style={{ display: 'flex', flexDirection: 'column', width: '100%', gap: "5px" }}>
                                                    <div>
                                                        <h4 >{answer.type_input_txt}</h4>

                                                    </div>
                                                    <div className={styles.slider_min_max}>

                                                        <input
                                                            id="slider"
                                                            type="range"
                                                            min={Math.min(Number(answer.min_len), Number(answer.max_len))}
                                                            max={Math.max(Number(answer.min_len), Number(answer.max_len))}
                                                            value={answersData.find(data => data.answerId === answer.id)?.sliderValue || Math.min(Number(answer.min_len), Number(answer.max_len))}
                                                            onChange={(event) => handleSliderChange(event, answer.id)}
                                                            style={{ width: '100%' }}
                                                        />
                                                        <span className={styles.slider_min_max_res}>
                                                            {
                                                                answersData.find(data => data.answerId === answer.id)?.sliderValue || Math.min(Number(answer.min_len), Number(answer.max_len))
                                                            }
                                                        </span>

                                                    </div>
                                                </div>
                                            }
                                            {(item.type_answer === 'numericInput') &&
                                                <input
                                                    type="number"
                                                    value={answersData.find(data => data.answerId === answer.id)?.type_input_int} // Начальное значение
                                                    onChange={(e) => handleNumericInputChange(e, answer.id)} // Обработчик для числового ввода
                                                    style={{ border: '1px solid rgb(41, 33, 33)', padding: '5px 10px', borderRadius: '6px', border: '0' }}
                                                    placeholder="Введите цифры"
                                                />
                                            }

                                            {(item.type_answer === 'textInput') &&
                                                <input
                                                    type="text"
                                                    value={answersData.find(data => data.answerId === answer.id)?.type_input_txt} // Начальное значение
                                                    onChange={(e) => handleTextInputChange(e, answer.id)} // Обработчик для текстового ввода
                                                    style={{ border: '1px solid rgb(123, 123, 123)', padding: '5px 10px', borderRadius: '6px', border: '0' }}
                                                    placeholder="Введите текст"
                                                />
                                            }
                                            {(item.type_answer === 'singleSelection') &&
                                                <>
                                                    <input
                                                        type="radio"
                                                        id={`answer-${answer.id}`}
                                                        checked={answersData.find(data => data.answerId === answer.id)?.isChecked || false} // Проверяем `isChecked`, если нет, то false
                                                        onChange={() => handleCheckboxChangeOne(answer.id)} // Обработчик изменения
                                                    />
                                                    <DraftContent draftData={answer.title} />
                                                </>
                                            }
                                            {(item.type_answer === 'multipleSelection') &&
                                                <>
                                                    <input
                                                        type="checkbox"
                                                        id={`answer-${answer.id}`}
                                                        checked={answersData.find(data => data.answerId === answer.id)?.isChecked || false} // Проверяем `isChecked`, если нет, то false
                                                        onChange={() => handleCheckboxChange(answer.id)} // Обработчик изменения
                                                    />
                                                    <DraftContent draftData={answer.title} />
                                                </>
                                            }

                                        </div>
                                    ) : (
                                        <>
                                            {item.type_answer === "freeTextAnswer" && (
                                                <div className={styles.answer_card_header}>
                                                    <div className={styles.answer_card_second_div} >
                                                        <textarea
                                                            value={answersData.find(data => data.answerId === answer.id)?.textValue}
                                                            className={styles.answer_card_header_textarea}
                                                            onChange={(e) => handleTextChange(e, answer.id)}
                                                            maxLength={item.max_len}
                                                            rows="4"
                                                            cols="50"
                                                            placeholder="Введите текст"
                                                        />
                                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'end' }}>

                                                            <span>{String(answersData.find(data => data.answerId === answer.id)?.textValue || '').length}

                                                                / {item.max_len}</span>
                                                        </div>
                                                    </div>
                                                </div>

                                            )}
                                            {item.type_answer === "fileUpload" && (
                                                <div className={styles.answer_card_header}>
                                                    <div className={styles.answer_card_second_div} >
                                                        <input
                                                            type="file"
                                                            id="file-upload"
                                                            className={styles.file_upload_input}
                                                            onChange={(event) => handleFileAndAnswerChange(event, answer.id)}
                                                        />
                                                        <label htmlFor="file-upload" className={styles.file_upload_label}>
                                                            {answersData.find(item => item.answerId === answer.id)?.file?.name || 'Загрузите изображение'}
                                                        </label>
                                                    </div>
                                                </div>
                                            )}

                                        </>
                                    )}
                                    {answer.file &&
                                        <img
                                            src={answer.file}
                                            className={styles.img_file}
                                        />
                                    }
                                </div>

                            </>
                        ))}
                         {item.comment ?
                             <div style={{ marginTop: '10px', display:'flex', flexDirection:'row', alignItems:'center', gap:'10px'}}>
                                
                                <DraftContent draftData={item.comment} />

                            </div> : null
                        }
                        {(item.type_answer !== 'infoText') &&
                            <>

                                {Number(item_selected) !== Number(item.id) &&
                                    <div className={styles.answer_card_selection_footer}>



                                        <button
                                            style={{
                                                padding: "5px 10px 5px 10px",
                                                fontSize: "14px",
                                                color: "#fff",
                                                border: "none",
                                                background: "#003BFF",
                                                borderRadius: "5px",
                                                cursor: "pointer"
                                            }}
                                            onClick={() => handleSubmit(item.id)}
                                        >
                                            Отправить ответ
                                        </button>


                                    </div>
                                }

                            </>
                        }
                       
                    </div>
                }
                {Number(item_selected) === Number(item.id) &&
                    <h4 style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        Ответ отправлен
                    </h4>
                }
            </div>

            <hr></hr>
            <Notification notify={notify} setNotify={setNotify} />
        </div >





    );
};

export default PartWorkItemUsedAll;
